import { useEffect } from "react";

declare global {
    interface Window {
        dataLayer?: object[];
    }
}

let gtmLoaded = false;
export function useGoogleTagManager(enabled: boolean, gtmId: string) {
    useEffect(() => {
        if (!enabled || gtmLoaded) {
            return;
        }
        (function (w: Window, d: Document, s: "script", l: string, i: string) {
            w[l] = w[l] || [];
            w[l].push({
                "gtm.start": new Date().getTime(),
                event: "gtm.js",
            });
            const f = d.getElementsByTagName(s)[0];
            const j = d.createElement<"script">(s);
            const dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f?.parentNode?.insertBefore(j, f);
        })(window, document, "script", "dataLayer", gtmId);

        gtmLoaded = true;
    }, [gtmId, enabled]);
}

export function GoogleTagManagerFallback({ trackingId }: { trackingId: string }) {
    return (
        <noscript>
            <iframe
                src={`https://www.googletagmanager.com/ns.html?id=${trackingId}`}
                height="0"
                width="0"
                style={{ display: "none", visibility: "hidden" }}
            ></iframe>
        </noscript>
    );
}
declare global {
    interface Window {
        [key: string]: object[];
    }
}
export const sendGTMEvent = (data: object) => {
    const dataLayer = "dataLayer";
    // define dataLayer so we can still queue up events before GTM init
    window[dataLayer] = window[dataLayer] || [];
    window[dataLayer].push(data);
};
